import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Spin, message } from 'antd';
import { CheckCircleOutlined, ExperimentOutlined, RocketOutlined, EditOutlined } from '@ant-design/icons';
import { login } from '../../auth';
import styles from './Auth.module.css';

const { Title, Text } = Typography;

const RegisterThanks = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          handleAutoLogin();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleAutoLogin = async () => {
    setIsLoggingIn(true);
    try {
      const savedCredentials = JSON.parse(
        localStorage.getItem('tempLoginCredentials') || '{}',
      );
      if (savedCredentials.email && savedCredentials.password) {
        await login(savedCredentials.email, savedCredentials.password);
        message.success('ログインしました');
        localStorage.removeItem('tempLoginCredentials');
        navigate('/aio/dashboard');
      } else {
        navigate('/login');
      }
    } catch (error) {
      console.error('Auto login failed:', error);
      navigate('/login');
    }
  };

  const steps = [
    { icon: <ExperimentOutlined />, label: 'チュートリアルで無料体験' },
    { icon: <RocketOutlined />, label: '14日間フルトライアル' },
    { icon: <EditOutlined />, label: '本格的なコンテンツ制作へ' },
  ];

  return (
    <div className={styles.registerPage}>
      <div style={{
        position: 'relative', zIndex: 1,
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '40px 20px',
      }}>
        <div style={{
          width: '100%', maxWidth: 460,
          background: 'rgba(255,255,255,0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: 16,
          padding: '48px 36px',
          boxShadow: '0 8px 40px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)',
          textAlign: 'center',
        }}>
          <div className="logo outside" style={{ marginBottom: 24 }}>
            <span>Ignite creativity with..</span>
            magicss
          </div>

          <CheckCircleOutlined style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }} />

          <Title level={3} style={{ marginBottom: 4, fontSize: 20, fontWeight: 600 }}>
            登録が完了しました！
          </Title>
          <Text type="secondary" style={{ fontSize: 13 }}>
            まずはチュートリアルで、1記事を無料で作成してみましょう。
          </Text>

          <div style={{
            display: 'flex', justifyContent: 'center', gap: 8,
            margin: '24px 0 20px', flexWrap: 'wrap',
          }}>
            {steps.map((s, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: 6,
                background: '#f5f0ff', borderRadius: 20,
                padding: '6px 14px', fontSize: 12, color: '#7c3aed', fontWeight: 600,
              }}>
                {s.icon}
                <span>{s.label}</span>
              </div>
            ))}
          </div>

          <div style={{ color: '#999', fontSize: 13 }}>
            {isLoggingIn ? (
              <span><Spin size="small" style={{ marginRight: 8 }} />ダッシュボードへ移動します...</span>
            ) : (
              <span>{countdown}秒後にダッシュボードへ移動します</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterThanks;
